import { ReactComponent as FlagIcon } from "./svg/ee-flag.svg";
import "../flag-icon.scss";

export const EEFlag = () => {
  return (
    <span className="flag-icon">
      <FlagIcon />
    </span>
  );
};
